import { Box, Divider, Typography } from '@mui/material';

export type MobileSectionProps = {
  label?: React.ReactNode;
  divider?: boolean;
  bottomDivider?: boolean;
  header?: string;
};

export const MobileSection: React.FC<MobileSectionProps> = ({ label, divider, bottomDivider, header, children }) => (
  <>
    {header && (
      <Box px={2}>
        <Typography variant="overline" color="textSecondary">
          {header}
        </Typography>
      </Box>
    )}
    {divider && <Divider />}
    <Box display="flex" width="100%" px={2} boxSizing="border-box" alignItems="center">
      {label && (
        <Box component={Typography} display="flex" flex="1" width="100%" mr={1}>
          {label}
        </Box>
      )}
      <Box display="flex" flex={label ? 'initial' : 1} overflow="hidden">
        {children}
      </Box>
    </Box>
    {bottomDivider && <Divider />}
  </>
);
